import React, { useState, useEffect } from 'react';
import { cardBackground, cross } from '../../../../assets';
import { SUBSCRIPTION_CREATE, SUBSCRIPTION_VERIFY } from '../../../services/seller/endpoint';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import AppDetailSkeleton from '../../../skeleton/AppDetailSkeleton';
import { Accordion, AccordionSummary, Button, Divider, Typography } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import ErrorIcon from '@mui/icons-material/Error';
import { captureGAEvent, gaPanelConfig } from '../../../shared/helper';
import { clearEvents } from '../../../utils/changeHeaderColor';



const Subscription = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [appName, setAppName] = useState('');
    const [amount, setAmount] = useState('');
    const [totalAmount, setTotalAmount] = useState('');
    const [icon, setIcon] = useState('');
    const [slug, setSlug] = useState('');
    const [appId, setAppId] = useState('');
    const auth = useSelector((state: any) => state.auth);
    const authUrl = process.env.REACT_APP_REDIRECT_URL;
    const nextRedirectUrl = process.env.REACT_APP_WEB_BASE_URL;
    const navigate = useNavigate();
    const location = useLocation();
    captureGAEvent("sras_payment__popup_display", "sras_payment__popup_display")
    const header_token = new URLSearchParams(location.search).get('subscribe_key');
    const handleLogin = () => {
        // Store the current URL before redirecting to the login page

        // Redirect to the login page with the current URL as nextRedirectUrl parameter
        window.location.href = `${authUrl}/login?nextRedirectUrl=${nextRedirectUrl}`;
    }

    useEffect(() => {
        const verifySubscription = async (token) => {
            try {
                if (!auth.token) {
                    // If not logged in, handle login action
                    handleLogin();
                    return;
                }

                // Make the API call to verify subscription
                const responseVerify = await fetch(SUBSCRIPTION_VERIFY(token), {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${auth.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        token: header_token
                    })
                });

                if (!responseVerify.ok) {
                    toast.error("Somthing went wrong");
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 2000);
                    throw new Error('Network response was not ok');
                }

                // Parse the response data
                const responseDataVerify = await responseVerify.json();
                setAppName(responseDataVerify.data.app_name);
                setAmount(responseDataVerify.data.amount);
                setTotalAmount(responseDataVerify.data.total_amount);
                setIcon(responseDataVerify.data.app_icon);
                setSlug(responseDataVerify.data.slug);
                setAppId(responseDataVerify.data.app_id);

            } catch (error) {

                setTimeout(() => {
                    window.location.href = "/";
                }, 2000);
                console.error('Error making verify API request:', error);
                // Handle errors
            }
        };

        verifySubscription(header_token);
    }, []);


    const navigateToAppDetails = (slug: string) => {
        gaPanelConfig.AppName = appName;
        gaPanelConfig.AppSlug = slug;
        gaPanelConfig.BtnText = "Cancel"
        captureGAEvent("sras_payment_popup_display", "sras_payment_popup_display")
        navigate(`/${slug}`);
    };

    const handleApprove = async () => {
        clearEvents();
        gaPanelConfig.AppName = appName;
        gaPanelConfig.AppSlug = slug;
        gaPanelConfig.BtnText = "Approve"
        captureGAEvent("sras_payment_popup_display", "sras_payment_popup_display")
        setIsLoading(true);
        try {
            // Make the API call to create subscription
            const responseCreate = await fetch(SUBSCRIPTION_CREATE(), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${auth.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    app_id: appId,
                    amount,
                    recurring_period: 30,
                    plan_type: 'recurring'
                })
            });

            if (!responseCreate.ok) {
                toast.error("Somthing went wrong");
                setTimeout(() => {
                    window.location.href = "/";
                }, 2000);
                // throw new Error('Something went wrong');
            }

            // Parse the response data
            const responseDataCreate = await responseCreate.json();

            // Redirect to the subscription_url
            const subscriptionUrl = responseDataCreate.data.subscription_url;
            window.open(subscriptionUrl, '_blank');

            navigateToAppDetails(slug);

            // Set the app name to state

        } catch (error) {
            console.error('Error making create API request:', error);

            // toast.error("Somthing went wrong");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
            // Handle errors
        } finally {
            setIsLoading(false);
        }
    };

    if (!appName) {
        return <>
            <ToastContainer />
            <AppDetailSkeleton />

        </>;
    }

    return (
        <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '150px', paddingBottom: '120px' }}>
            <ToastContainer />

            <div className='container' style={{ display: 'flex', flexDirection: 'column', border: '1px solid #E2E2E2', borderRadius: '14px', opacity: 1, boxShadow: 'none', padding: '40px', height: 'auto', width: '600px', position: 'relative', background: "white" }}>
                <img
                    src={cross}
                    alt="image"
                    style={{ position: 'absolute', right: '20px', width: "33px", height: "auto", cursor: "pointer" }}
                    onClick={() => navigateToAppDetails(slug)}
                />
                <div style={{ fontFamily: 'sfprobold', fontSize: '24px', paddingBottom: '20px' }}> Approve Subscription</div>
                <div className='container' style={{ display: 'flex', flexDirection: 'row', gap: '30px', paddingBottom: '20px' }}>
                    <div className="rounded-sm overflow-hidden relative group-hover:scale-[1.025] w-appIcon--sm" style={{ background: '#FFFFFF', border: '1px solid #E2E2E2', borderRadius: '14px', opacity: 1, height: '70px', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: 'none', padding: '5px' }}>
                        <img style={{ borderRadius: "16px", maxWidth: '100%', maxHeight: '100%', height: '80px', width: '80px', }} alt="" src={icon} className="block relative shrink-0 w-appIcon--sm" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className='container' style={{ fontFamily: 'sfprobold', fontSize: '20px' }}> {appName + "-Optimize Your Shipments"} </div>
                        <div style={{ fontFamily: 'sfproregular', fontSize: '16px' }}> by Shiprocket</div>
                    </div>
                </div>
                <Divider />
                <div className='container' style={{ fontFamily: 'sfprobold', fontSize: '20px', lineHeight: "20px", paddingTop: '20px', paddingBottom: '15px' }}>{"Plan: " + appName + ' Billing Plan - ' + " Rs." + amount}</div>
                <div style={{ background: "#F9FAFB", borderRadius: "15px" }}>
                    <div className='container' style={{ paddingTop: "10px", fontFamily: 'sfprobold', fontSize: '18px', lineHeight: "20px", paddingLeft: '14px', paddingBottom: '5px' }}> App Spending limit</div>
                    <div className='container' style={{ fontFamily: 'sfproregular', fontSize: '16px', paddingLeft: '15px', color: '#5F5F5F', lineHeight: '24px' }}> You will incur charges based on your usage in {appName}, subjected to a maximum spending limit of Rs. {totalAmount} every 30 days. Post-approval, you may modify this limit. </div>
                </div>
                <div className='container' style={{ fontFamily: 'sfprobold', fontSize: '20px', lineHeight: "20px", paddingTop: '20px', paddingBottom: '10px' }}> Payment Method</div>
                <div style={{ background: "#F9FAFB", borderRadius: "15px", padding: "12px" }}>

                    <div className='container' style={{ fontFamily: 'sfproregular', fontSize: '16px', lineHeight: "20px", color: '#5F5F5F', paddingTop: "2px", }}> Charges will be processed using your Shiprocket Wallet.</div>
                    <div className='container' style={{ fontFamily: 'sfproregular', fontSize: '16px', lineHeight: "20px", paddingTop: "8px", color: '#5F5F5F' }}> Upon approval, charges for {appName} will be reflected in your monthly invoice and threshold bills </div>
                </div>
                <div className='container' style={{ background: '#ffefdb', alignContent: 'center', padding: '10px', marginTop: "15px" }}>
                    <span style={{ marginRight: '5px' }}> <ErrorIcon sx={{ color: '#e8a75a', fontSize: '18px' }} /></span>
                    <span>Please note that government taxes and additional charges may apply </span>
                </div>
                <div className='container' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '10px', paddingTop: '20px' }}>
                    <div> <Button sx={{ width: "96px", borderRadius: "8px", color: "#344054", borderColor: "#D0D5DD" }} variant="outlined" onClick={() => navigateToAppDetails(slug)}>Cancel</Button></div>
                    <div> <Button sx={{ backgroundColor: "#735AE5", width: "96px", borderRadius: "8px" }} variant="contained" onClick={handleApprove}> {isLoading ? 'Loading...' : 'Approve'}</Button> </div>
                </div>
            </div>





        </div>
    );
};

export default Subscription;
